<template>
  <div class="box">
    <div class="banner">
      <img :src="banner" alt="">
      <div class="banner-text">
        <h6 class="banner-text-h6">购物管理系统</h6>
        <!-- <h6 class="banner-text-h6">趣旅淘系统</h6> -->
        <!-- <p class="banner-text-p">每一位导游都是您的销售员</p> -->
        <p class="banner-text-p">哪里有趣哪里淘</p>
        <router-link  :to="{path:'/league',query: {sysTtype:sysTtype}}"><div class="banner-btn">申请试用</div></router-link>
      </div>

    </div>
    <div class="center-box center clearfix">
      <div class="indexCase clearfix">
        <div class="indexTitle-box">
          <h5 class="indexTitle">SYSTEM COMPOSITION</h5>
          <h6 class="indexSubtitle">系统组成</h6>
          <div class="select-head">
            <span :class="selectIndex==1?'center-act':''"  @click="selectCenter(1)">趣旅淘小程序</span>
            <span :class="selectIndex==2?'center-act':''" @click="selectCenter(2)">趣旅淘后台</span>
          </div>
          <div class="select-center">
            <div class="select-wx" v-if="selectIndex==1"></div>
            <div class="select-backstage" v-if="selectIndex==2">
              <router-link  :to="{path:'/league',query: {sysTtype:sysTtype}}"><div class="btn">申请试用</div></router-link>
            </div>
          </div>
        </div>
      </div>    
    </div>

    <div class="ApplicationForm">
    </div>
    <div class="flow">
      <img :src="flow" alt=""> 
    </div>
    <div class="pay-flow">
      <router-link  :to="{path:'/league',query: {sysTtype:sysTtype}}"><div class="tryout">申请试用</div></router-link>
    </div>
    <div class="empty"></div>
  </div>
</template>

<script>
import global_ from './../store/global'
export default {
  name: 'Cooperation',
  data () {
    return {
      selectIndex:1,
      sendSelected:'cooperation',
      colourClass:'',
      banner: global_.imgUrl+'gouwu_banner.jpg',
      flow:  global_.imgUrl+'step_2.jpg',
      advantageIcon:  global_.imgUrl+'advantage-icon',
      ApplicationFormIcon:  global_.imgUrl+'ApplicationFormIcon',
      href:'#/cooperation/register',
      sysTtype:1,
    }
  },
  methods: {
    selectCenter(index){
      this.selectIndex=index
    }
  },
  beforeMount(){
    var session=sessionStorage.getItem('GWcustomer');
    if(session!=null){
      this.href='#/cooperation/information';
    }
  },
  mounted(){
    this.$emit('nav',this.sendSelected,this.colourClass);
  }
  
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .banner{
    width: 100%;
    height: 700px;
    min-width: 1200px;
    position: relative;
    overflow: hidden;
    img{
      width: 1920px;
      max-width: inherit;
      position: relative;
      left: 50%;
      top: 0;
      margin-left: -960px;
    }
    .banner-text{
      position: absolute;
      height: 100%;
      width: 1200px;
      top: 0;
      left: 50%;
      margin-left: -600px;
      text-align: center;
      color: #fff;
      .banner-text-h6{
        font-size: 42px;
        font-weight: 100;
        margin-top: 200px;
        line-height: 70px;
      }
      .banner-text-p{
        font-size: 20px;
        font-weight: 100;
        margin-top: 0px;
        line-height: 70px;
      }
      .banner-btn{
        width: 200px;
        height:50px;
        line-height: 50px;
        text-align: center;
        margin: 20px auto;
        color: #fff;
        background: linear-gradient(to right, #ff4c67 0%,#ff904d 100%);
        border-radius: 4px;
        cursor: pointer;
      }
    }
  }
  .flow{
    width: 100%;
    height: 400px;
    min-width: 1200px;
    position: relative;
    overflow: hidden;
    img{
      width: 1920px;
      max-width: inherit;
      position: relative;
      left: 50%;
      top: 0;
      margin-left: -960px;
    }
  }

  .pay-flow{
    width: 100%;
    height: 386px;
    min-width: 1200px;
    position: relative;
    overflow: hidden;
    background: #00bff6 url('../assets/images/step_info_1.jpg') center center no-repeat;
    .tryout{
      position: absolute;
      top: 300px;
      bottom: 0px;
      left: 40px;
      right:0px;
      margin: auto;
      width:200px;
      height: 50px;
      line-height: 50px;
      text-align: center;
      color: #fff;
      background: linear-gradient(to right, #ff4d67 0%,#ff914d 100%);
      border-radius: 4px;
      cursor: pointer;
    }
  }
  .center-box{
    width: 100%;
    height: 890px;
  }

  .indexCase{
    margin: 80px 0 140px;
    .indexTitle-box{
      margin-bottom: 40px;
      text-align: center;
      .indexTitle{
        font-size: 32px;
        font-weight: bold;
        color: #cdeddd;
        line-height: 40px;
      }
      .indexSubtitle{
        font-size: 24px;
        color: #585858;
        line-height: 32px;
        font-weight: normal;
        text-transform:uppercase;
        margin: 5px 0;
      }
    }

    .indexService{
      margin: 60px 0 0;
      display: flex;
      .indexService-li{
        // flex-grow: 1;
        text-align: center;
        width: 25%;
        img{
          display: block;
          margin: 30px auto 20px;
        }
        .advantage-text{
          margin: 0 20px;
          h6{
            font-size: 20px;
            line-height: 28px;
            color: #333; 
            margin-bottom: 10px;
            // text-indent: 15px;
          }
          p{
            font-size: 14px;
            line-height: 24px;
            color: #999; 
          }
        }
        
      }
    }
    
  }
  .ApplicationForm{
    // background: #00bff6 url('../assets/images/flow_02.jpg') center center no-repeat;
    background: #00bff6 url('../assets/images/flow_02.png') center center no-repeat;
    width: 100%;
    height: 600px;
    min-width: 1200px;
    .indexCase{
      margin: 80px 0;
    }
    .indexTitle-box{
      .indexTitle,.indexSubtitle{
        color: #fff;
      }
      
    }
    .indexService{
      
      .indexService-li{
        .advantage-text{
          h6{
            color: #fff; 
          }
          p{
            color: #fff; 
          }
        }
      }
    }

    
  }
  .JoinUs{
    span{
      width: 18px;
      height: 18px;
      border: 2px solid #ff0000;
      border-bottom:none;
      &.JoinUs-l{
        border-right: none;
      }
      &.JoinUs-r{
        border-left: none;
      }
    }
    .JoinUs-text{
      font-size: 14px;
      color: #333;
      margin: 25px;
      text-align: center;
      line-height: 24px;
    }
    .JoinUs-Btn{
      display: block;
      width: 260px;
      height: 60px;
      text-align: center;
      line-height: 60px;
      border-radius: 10px;
      margin: 0 auto;
      background-color: #ff8c00;
      font-size: 20px;
      color: #fff;
      margin-top: 80px;
      &:hover{
        background-color: #fe981b;
      }
    }
  }
  .select-head{
    color: #363636;
    margin-top: 20px;
    span{
      padding-bottom: 6px;
      margin-right: 100px;
      cursor: pointer;
    }
    span:nth-child(1){
      margin-left: 100px;
    }
    .center-act{
      color: #58d0a4;
      border-bottom: 2px solid #58d0a4;
    }
  }
  .select-center{
    width: 1000px;
    height: 520px;
    margin: 0px auto;
    margin-top: 40px;
    background-color: #f5f5f5;
    .select-wx{
      width: 100%;
      height:100%;
      // background: url('../assets/images/gouwu_wx.jpg') center 20px no-repeat;
      background: url('../assets/images/gouwu_wx2.jpg') center 20px no-repeat;
      background-size: 100%;

    }
    .select-backstage{
      position: relative;
      width: 100%;
      height:100%;
      background: url('../assets/images/gouwu_backstage.jpg') center 20px no-repeat;
      background-size: 100%;
      .btn{
        width: 90px;
        height: 30px;
        position: absolute;
        left:68px;
        right: 0px;
        top: 310px;
        bottom: 0px;
        margin: auto;
        line-height: 30px;
        color: #5dcfa5;
        text-align: center;
        border-radius: 4px;
        border: 1px solid #5dcfa5;
        cursor: pointer;
      }
    }

  }
  .empty{
    width: 100%;
    height: 60px;
    background-color: #fff;
  }

</style>



// WEBPACK FOOTER //
// src/components/withGroup.vue